import { type INotificationFinancingParams } from 'dto/NotificationDTO/financing'
import { type INotificationOrderParams } from 'dto/NotificationDTO/order'

export function getFinancingId(params = {}) {
  return (params as INotificationFinancingParams).financingId
}

export function getSimulationId(params = {}) {
  return (params as INotificationFinancingParams).simulationId
}

export function getOrderCode(params = {}) {
  return (params as INotificationOrderParams).code
}
